/**
 * Sensible starter rulepack — user can replace via lockboxStore.setRulepack.
 * @type {import('./types.js').LockboxRulepack}
 */
export const DEFAULT_RULEPACK = {
  version: 1,
  alwaysAllowCategories: ["navigation", "banking", "utility", "work_comms"],
  alwaysBlockCategories: [],
  timeWindows: [
    {
      id: "tw_evening_anime",
      name: "Block anime-style apps after 8 PM",
      startHour: 20,
      startMinute: 0,
      endHour: 23,
      endMinute: 59,
      blockCategories: ["anime_streaming", "manga_reading", "shortform_feed"],
      onlyInModes: [],
    },
  ],
  modeStrict: [
    {
      modeId: "work",
      blockedCategories: ["anime_streaming", "manga_reading", "shortform_feed", "entertainment_discovery"],
      extraBlockCategories: [],
    },
    {
      modeId: "strict",
      blockedCategories: [
        "anime_streaming",
        "manga_reading",
        "shortform_feed",
        "entertainment_discovery",
        "gaming_session",
      ],
      extraBlockCategories: ["anime_streaming", "manga_reading", "shortform_feed", "entertainment_discovery", "gaming_session"],
    },
    {
      modeId: "sleep",
      blockedCategories: ["shortform_feed", "gaming_session", "entertainment_discovery", "anime_streaming"],
      extraBlockCategories: ["shortform_feed", "gaming_session", "entertainment_discovery"],
    },
  ],
  emergencyPolicy: {
    strategy: "pause_automatic_blocks",
  },
};
